<template>
  <div class="series aurora" id="aurora">
    <transition name="fade">
      <div v-if="loading" class="loading">
      </div>
      <div v-else class="scroll-group" id="scroll-tracking-aurora">

        <Transition name="description">
          <div class="description-wrapper mobile" :class="{ 'unfold' : unfold }">
            <div class="foldout-button" @click="unfold = !unfold" :class="{ 'unfold' : unfold }">
              <p class="description-meta" v-html="sorted[descriptionId].meta"></p>
              <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
              <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
            </div>
            <p class="description-content" v-if="unfold" v-html="sorted[descriptionId].content"></p>
            <p class="description-credits" v-if="unfold" v-html="sorted[descriptionId].credits"></p>
          </div>
        </Transition>

        <div v-for="(group, groupIndex) in sorted" :key="group.id"
             class="groups" :id="group.id">

          <Transition name="description">
            <div v-if="group.content || group.meta" class="description-wrapper desktop">
              <div class="foldout-button" @click="unfold = !unfold">
                <p class="description-meta" v-html="group.meta" @click="unfold = !unfold"></p>
                <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
                <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
              </div>
              <p class="description-content" v-if="unfold" v-html="group.content"></p>
              <p class="description-credits" v-if="unfold" v-html="group.credits"></p>
            </div>
          </Transition>

          <div v-for="(object, index) in group.imageslist" :key="object.id" class="item-container"
               :class="{ 'first' : index === 0, 'next-group' : index === 0 && groupIndex > 0 }">
            <video v-if="object.media && object.media.match(/^.*\.(mp4)/)"
                   preload="auto"
                   controls
                   class="video-container"
                   :poster="$store.state.$imageBaseURL + object.id + '/' + object.poster + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken">
              <source :src="$store.state.$fileBaseURL + object.id + '/' + object.media"/>
            </video>

            <div v-else class="img-container"
                 @click="showLightbox($event, object)">
              <div class="main">
                <ImageLoader
                    :small="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=16&q=50&dpr=1&token=' + $store.state.$imageToken"
                    :trueSize="$store.state.$imageHackURL + object.id + '/' + object.cover + '?w=500&q=100&dpr=1&token=' + $store.state.$imageToken"/>
              </div>
              <div class="mask">
                <ImageLoader
                    :small="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=16&q=50&dpr=1&token=' + $store.state.$imageToken"
                    :trueSize="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=100&q=60&dpr=1&token=' + $store.state.$imageToken"
                    :loadingStyle="'eager'"/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="lightboxImage" id="image-lightbox">
      <div id="lightbox-backdrop"></div>
      <p class="buttons">
        <svg id="close" @click="lightboxImage = null"
             :style="{ opacity: lightboxImage ? '1' : '0',
                       pointerEvents: lightboxImage ? 'all' : 'none'}"
             xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="36"
             height="36" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none"
             stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </p>
      <ImageLoader id="lightbox-image"
                   :small="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.cover + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                   :trueSize="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.cover + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken"/>
    </div>

  </div>
</template>

<script>
import scrollManager from '@/assets/js/scrollManager.js';
import ImageLoader from '../components/ImageLoader.vue'

export default {
  name: 'Home',
  components: {
    ImageLoader
  },
  data() {
    return {
      photoArray: [],
      descriptionId: 0,
      unfold: window.innerWidth >= 800,
      loading: true,
      lightboxImage: null
    }
  },
  mounted() {
    this.fetchContent();
  },
  computed: {
    sorted() {
      return this.photoArray.slice().sort((a, b) => a.sort_index - b.sort_index);
    },
    mobile() {
      return this.$store.state.$mobile;
    }
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        this.$nextTick(() => {
          let scrolltracking = document.getElementById("scroll-tracking-aurora");
          let scrollparent = document.getElementById("aurora");
          if (scrolltracking) {
            scrolltracking.addEventListener("wheel", (e) => {
              this.changeDescription(e);
            }, {passive: true});

            scrollparent.addEventListener("scroll", (e) => {
              this.changeDescription(e);
            }, {passive: true});

            scrolltracking.addEventListener("touchmove", (e) => {
              this.changeDescription(e);
            }, {passive: true});
          }

          if (!this.mobile) {
            const scrollableDescriptions = document.querySelectorAll('.description-wrapper.desktop');

            scrollableDescriptions.forEach(scrollable => {

              scrollable.addEventListener('wheel', function(e) {
                const { scrollTop, scrollHeight, clientHeight } = scrollable;
                const delta = e.deltaY;

                const atTop = scrollTop === 0;
                const atBottom = scrollTop + clientHeight >= scrollHeight;

                if ((atTop && delta < 0) || (atBottom && delta > 0)) {
                  return;
                }

                e.stopPropagation();
              }, { passive: false });
            });
          }
        });
      }
    }
  },
  methods: {
    showLightbox(event, object) {
      event.stopPropagation();
      this.lightboxImage = object;
    },
    changeDescription() {
      let series1 = document.getElementById("aurora");
      let blocks = document.getElementsByClassName("groups");

      let i = 0;
      for (let block of blocks) {
        this.isElementVisible(block, series1, i);
        i++;
      }
    },
    isElementVisible(el, holder, i) {
      holder = holder || document.body;
      const elRect = el.getBoundingClientRect();
      const holderRect = holder.offsetWidth / 2;

      if (elRect.left <= holderRect) {
        if (this.descriptionId !== el.id) {
          this.descriptionId = i;
        }
      }
    },
    fetchContent() {
      fetch(`https://marinkagrondel.com/cms/api/entries?id=photo-series/aurora&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not OK');
            } else {
              response.json()
                  .then((data) => {

                    let array = Object.values(data.data);
                    let sorted = array.slice().sort((a, b) => a.sort_index - b.sort_index);

                    for (let [i, installation] of sorted.entries()) {
                      if (installation.visibility === "visible") {
                        this.photoArray[i] = installation;
                        this.photoArray[i].imageslist = [];

                        fetch(`https://marinkagrondel.com/cms/api/entries?id=${installation.id}&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
                            .then((response) => {
                              if (!response.ok) {
                                throw new Error('Network response was not OK')
                              } else
                                response.json()
                                    .then((imageData) => {
                                      // convert Object to Array !!!
                                      let entries = Object.values(imageData.data);
                                      let sorted = entries.slice().sort((a, b) => a.sort_index - b.sort_index);
                                      this.photoArray[i].imageslist = sorted;

                                      let series1 = document.getElementById("aurora");

                                      this.loading = false;
                                      scrollManager(series1);
                                    })
                            })
                      }
                    }
                  });
            }
          })
    }
  }
}
</script>


<style scoped>
#aurora #image-lightbox {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 25px;
  z-index:1000;
}

#aurora #image-lightbox img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#aurora #lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(227, 227, 227, 0.9);
  pointer-events: none;
  z-index: 999;
}

#aurora #lightbox-image {
  z-index: 1000;
}

#aurora .buttons {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
}

#aurora #close {
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
  z-index: 1001;
}

@-webkit-keyframes opacityanim {
  0% {
    opacity: 0.55;
  }

  100% {
    opacity: 0.95;
  }
}

@keyframes opacityanim {
  0% {
    opacity: 0.55;
  }

  100% {
    opacity: 0.95;
  }
}

.aurora {
  background-color: var(--aurora-bg-color);
  padding: 0px 30px;
}

.mask, .main {
  height: 100%;
}

.mask {
  position: absolute;
  top: 0;
  padding: 50px;
  z-index: 0;
  margin: 50px;

  opacity: 1;
  transition: opacity 1.5s;
  transform: translate(100px, -100px) scaleX(100%) scaleY(100%) translate3d(0, 0, 0);
  filter: brightness(140%) contrast(250%);
  mix-blend-mode: screen;
}

.mask img {
  filter: blur(50px);
}

.img-container:hover .main {
  opacity: 1;
}

.img-container {
  overflow: visible;
}

.main {
  position: relative;
  padding: var(--photo-padding) 300px var(--photo-padding) 0;
  z-index: 10;
  opacity: 0.5;
  transition: opacity 1.5s;
}

.aurora .video-container {
  max-width: 80vw;
  opacity: 0.5;
  padding: var(--photo-padding) 300px var(--photo-padding) 0;
}

.aurora .video-container:hover {
  opacity: 1;
}

.aurora .img-container,
.aurora .video-container {
  height: 100%;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  flex-grow: 1;
  transition: background-color 0.5s, opacity 1.5s;
  margin: 0;
}

.img-container img,
.video-container video {
  display: block;
  width: auto;
  height: 100%;
  background-color : transparent;
}

video::-webkit-media-controls-panel {
  background-image: linear-gradient(transparent, transparent) !important;
}

audio::-webkit-media-controls-timeline,
video::-webkit-media-controls-timeline {
  display: none;
}


#aurora .description-wrapper.desktop {
  margin-bottom: 30px;
}


@media only screen and (max-width: 800px) {
  .video-container video {
    height: fit-content;
  }

  .item-container:has(.video-container) {
    height: 45vh;
    padding-right: 300px;
  }

  .groups {
    margin-top: calc(45vh + 20px);
  }

  .item-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    justify-items: center;
  }

  .groups .item-container:not(.first) {
    margin-left: -300px;
  }

  .groups .item-container.first.next-group {
    margin-left: -220px;
  }


  .aurora .video-container {
    height: fit-content;
    width: 90vw;
    padding: 0;
    object-fit: contain;
  }

  .main {
    opacity: 1;
    padding: 0 300px 0 0;
    height: 100%;
    width: auto;
  }

  .mask {
    width: auto;
    height: 100%;
    transform: translate(100px, -40px) scaleX(90%) scaleY(90%) translate3d(0, 0, 0);
    opacity: 0.8;
  }


  .main img {
    width: auto;
    height: 45vh;
  }

  #aurora .description-wrapper.mobile {
    padding: var(--vertical-padding) var(--horizontal-padding) var(--vertical-padding) var(--horizontal-padding);
    padding-top: 1.5rem;
    bottom: 0;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    left: 0;
    display: inline-block;
    background-color: transparent;
  }

  #aurora .description-wrapper.mobile.unfold {
    background-image: linear-gradient(to right, rgb(204, 204, 204) 4%, rgb(215, 215, 215), #e1c3a9);

    -webkit-mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
    mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
  }



  .description-wrapper.desktop {
    display: none;
  }

  #aurora .img-container,
  #aurora .video-container {
    margin-right: 40px;
  }

  @media only screen and (max-width: 800px) {
    .aurora .video-container {
      opacity: 1;
    }
  }

}
</style>